import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';

import { ReactComponent as HardwareIcKeyboardArrowDown24px } from '../../../assets/icons/hardware/ic_keyboard_arrow_down_24px.svg';
import { MenuItemGroupProvider } from './menu-item-group.context';

let nextUniqueId;
nextUniqueId = 0;

const defaultIcons = {
  expandToggle: <HardwareIcKeyboardArrowDown24px />
};

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {boolean} [open]
 * @prop {string} [className]
 * @prop {string} [groupName]
 * @prop {{}} [openButtonProps]
 * @prop {{expandToggle: React.ReactNode}} [icons]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifMenuItemGroup = (props) => {
  const {
    children,
    className = '',
    open = false,
    groupName = '',
    openButtonProps = {},
    icons: userIcons = {},
    ...other
  } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const [menuOpen, setMenuOpen] = useState(open);

  const classes = classNames({
    'motif-menu-item-group': true,
    'motif-menu-item-group-open': menuOpen,
    [className]: true
  });

  const arrowClasses = classNames({
    'motif-menu-item-group-arrow': true,
    'motif-menu-item-group-arrow-open': menuOpen
  });

  const sectionId = `motif-menu-item-group-section-${nextUniqueId++}`;
  const id = `motif-menu-item-group-${nextUniqueId++}`;

  return (
    <MenuItemGroupProvider value={{ menuOpen, setMenuOpen }}>
      <li className={classes} {...other} data-motif-menu-item-group>
        <button
          className="motif-menu-item-group-button"
          aria-controls={sectionId}
          id={id}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
          {...openButtonProps}
        >
          <span className="motif-menu-item-group-name">{groupName}</span>
          <span className={arrowClasses}>{icons.expandToggle}</span>
        </button>
        <AnimateHeight duration={150} height={menuOpen ? 'auto' : 0}>
          <ul className="motif-menu-list" id={sectionId} role="region" aria-labelledby={id}>
            {children}
          </ul>
        </AnimateHeight>
      </li>
    </MenuItemGroupProvider>
  );
};

MotifMenuItemGroup.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  groupName: PropTypes.string,
  className: PropTypes.string,
  openButtonProps: PropTypes.instanceOf(Object),
  icons: PropTypes.shape({
    expandToggle: PropTypes.node
  })
};

export { MotifMenuItemGroup };
